import React, { CSSProperties, useMemo } from 'react';

import { hexToHSLAndDarken } from '../../../helpers/colorsTransformation';
import { BrandingConfig } from '../../../types/websheet';

interface Props {
  values: BrandingConfig;
}

export const useGetStyles = ({ values }: Props) => {
  const backgroundColorIsWhite =
    values.colorBackground === '#FFFFFF' ||
    values.colorBackground === 'rgb(255, 255, 255)' ||
    values.colorBackground === 'hsl(0, 0%, 100%)' ||
    values.colorBackground === 'white';

  return useMemo(() => {
    return {
      '--background': values?.colorBackground,
      '--background-darker': hexToHSLAndDarken(values.colorBackground, 5.5),
      '--watch-image-background':
        values?.color_style_config?.watch_background || '#4397C7',
      // Fonts
      '--font-family-headings': `${values.fontTitle}, sans-serif`,
      '--font-family-body': `${values.fontParagraph}, sans-serif`,
      // Colors
      '--color-heading': values.colorAccent,
      '--color-body': values.colorParagraphText,
      '--color-links': values.colorLink,
      '--color-button': values.colorButton,
      '--color-button-active': values.colorButtonClick,
      '--color-button-text': values.colorButtonText,
      '--color-body-background': values.colorBackground,
      '--color-error-message': values.colorErrorDialog,
      '--color-success-message': '#14af6e',
      '--input-border': backgroundColorIsWhite ? '#000000 1px solid' : 'none',
      backgroundColor: values?.colorBackground,
    };
  }, [values, backgroundColorIsWhite]) as CSSProperties;
};
